/* ===========================================================================
   event.js — compra del boleto en la landing de evento.
   Corre DESPUÉS de academy.js, que ya se encarga del motion, el acordeón,
   los anclajes y el CTA pegajoso. Aquí solo vive lo que es del evento:
   cuenta regresiva, selector de talla, campo de tutor y el envío a /cart/add.
   Sin dependencias: si algo falla, el <form> nativo sigue funcionando y
   manda al carrito con return_to=/checkout.
   =========================================================================== */
(function () {
  'use strict';

  var D = document;
  var $ = function (sel, ctx) { return (ctx || D).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || D).querySelectorAll(sel)); };
  var pad2 = function (n) { return String(n).padStart(2, '0'); };

  /* ------------------------- Cuenta regresiva ---------------------------- */
  function initCountdown() {
    var el = $('[data-uk-countdown]');
    if (!el) return;
    var target = new Date(el.getAttribute('data-uk-countdown'));
    if (isNaN(target.getTime())) return;

    var box = el.closest('.uk-count') || el;
    var dEl = $('[data-cd-d]', el), hEl = $('[data-cd-h]', el),
        mEl = $('[data-cd-m]', el), sEl = $('[data-cd-s]', el);

    function tick() {
      var diff = target.getTime() - Date.now();
      if (diff <= 0) {
        box.classList.add('is-past');
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      dEl.textContent = Math.floor(s / 86400);
      hEl.textContent = pad2(Math.floor(s / 3600) % 24);
      mEl.textContent = pad2(Math.floor(s / 60) % 60);
      sEl.textContent = pad2(s % 60);
    }
    tick();
    var timer = setInterval(tick, 1000);
  }

  /* --------------------------- Compra ------------------------------------ */
  function initBuy() {
    var form = $('#uk-event-form');
    if (!form) return;

    var submitBtn = $('[data-buy-submit]', form);
    var priceOut = $('[data-buy-price]', form);
    var errorBox = $('[data-form-error]', form);
    var sizesErr = $('[data-err-sizes]', form);
    var tutorField = $('[data-tutor-field]', form);
    var tutorInput = tutorField ? $('input', tutorField) : null;
    var edad = form.elements['properties[Edad]'];
    var money = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN';

    /* Formato de precio: el del tema, sin inventar separadores. */
    function fmt(cents) {
      try {
        return new Intl.NumberFormat('es-MX', {
          style: 'currency', currency: money, minimumFractionDigits: 0, maximumFractionDigits: 0
        }).format(cents / 100);
      } catch (e) {
        return '$' + Math.round(cents / 100);
      }
    }

    /* Marca en rojo las tallas con 5 o menos lugares — el dato viene del
       inventario real, no de un contador decorativo. */
    $$('.uk-size input', form).forEach(function (r) {
      var left = parseInt(r.getAttribute('data-left') || '0', 10);
      if (left > 0 && left <= 5) {
        var stock = $('.uk-size__stock', r.parentNode);
        if (stock) stock.classList.add('is-low');
      }
    });

    function refreshPrice() {
      var checked = $('.uk-size input:checked', form);
      if (checked && priceOut) priceOut.textContent = fmt(parseInt(checked.getAttribute('data-price'), 10));
      if (checked && sizesErr) sizesErr.textContent = '';
    }
    $$('.uk-size input', form).forEach(function (r) {
      r.addEventListener('change', refreshPrice);
    });
    refreshPrice();

    /* Menor de edad → pedimos tutor. El campo nace oculto y sin required
       para no bloquear la validación nativa cuando no aplica. */
    function refreshTutor() {
      if (!tutorField || !tutorInput || !edad) return;
      var age = parseInt(edad.value, 10);
      var minor = !isNaN(age) && age < 18;
      tutorField.hidden = !minor;
      tutorInput.required = minor;
      if (!minor) tutorInput.value = '';
    }
    if (edad) edad.addEventListener('input', refreshTutor);
    refreshTutor();

    /* Consentimientos: cada checkbox activa un hidden con la constancia que
       viaja dentro del pedido. Si no lo marcan, el hidden queda disabled y
       Shopify ni siquiera recibe la propiedad. */
    var stamp = new Date().toISOString().slice(0, 10);
    $$('[data-consent]', form).forEach(function (chk) {
      var hidden = D.getElementById(chk.getAttribute('data-prop'));
      chk.addEventListener('change', function () {
        if (!hidden) return;
        hidden.disabled = !chk.checked;
        hidden.value = chk.checked ? ('Aceptado el ' + stamp) : '';
      });
    });

    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg;
      errorBox.hidden = false;
      errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    form.addEventListener('submit', function (ev) {
      if (errorBox) errorBox.hidden = true;

      var checked = $('.uk-size input:checked', form);
      if (!checked) {
        ev.preventDefault();
        if (sizesErr) sizesErr.textContent = 'Elige la talla de tu jersey.';
        return;
      }
      if (!form.checkValidity()) {
        ev.preventDefault();
        form.reportValidity();
        return;
      }

      /* Camino rápido: /cart/add.js y de ahí directo al checkout. Si el fetch
         falla (red, bloqueador), dejamos que el POST nativo haga su trabajo. */
      if (!window.fetch) return;
      ev.preventDefault();
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body.description || body.message || 'No se pudo apartar el lugar.');
            return body;
          });
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          showError(err.message === 'Failed to fetch'
            ? 'Se cortó la conexión. Intenta de nuevo.'
            : err.message);
        });
    });
  }

  /* ------------------- Pausa del video del hero -------------------------- */
  // academy.js monta el video (data-uk-lazyvideo) y lo reanuda al volver a
  // pantalla; aquí solo vive el botón. Si la persona lo pausó, se respeta
  // aunque el observer vuelva a pedir play().
  function initVideoToggle() {
    var v = $('[data-uk-lazyvideo]');
    var btn = $('[data-uk-video-toggle]');
    if (!v || !btn) return;
    var userPaused = false;
    v.addEventListener('playing', function () { btn.hidden = false; }, { once: true });
    v.addEventListener('play', function () { if (userPaused) v.pause(); });
    btn.addEventListener('click', function () {
      userPaused = !userPaused;
      btn.setAttribute('aria-pressed', String(userPaused));
      btn.textContent = userPaused ? 'Reproducir video' : 'Pausar video';
      if (userPaused) { v.pause(); return; }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function boot() {
    try { initCountdown(); }   catch (e) { console.warn('[event] countdown:', e); }
    try { initBuy(); }         catch (e) { console.warn('[event] compra:', e); }
    try { initVideoToggle(); } catch (e) { console.warn('[event] video:', e); }
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
